export const SofiaEvents = {};

SofiaEvents.hasActiveEvent = () => {
  return SofiaEvents.isSecondEvent();
}

SofiaEvents.displayHint = () => {
  return SofiaEvents.isSecondEvent();
}

/*
 - take a lesson (20$)
 */
SofiaEvents.genericTalk = () => {
  return !SofiaEvents.hasActiveEvent() && !SofiaEvents.isFirstEvent();
}

SofiaEvents.isFirstEvent = () => {
  return !EventStateService.sofiaFirstEvent;
}

SofiaEvents.isSecondEvent = () => {
  if(EventStateService.sofiaDailyEventChecked) {
    return false;
  }

  // czy już pierwszy event
  if(!EventStateService.sofiaFirstEvent) {
    return false;
  }

  // czy już drugi rozdział
  if(!EventStateService.secondChapterIntro) {
    return false;
  }

  return !EventStateService.sofiaSecondEvent;
}

